import { RoutingPattern } from '../../Routes';

export const sabbaticalLeavesUrl = `${RoutingPattern.admin}/sabbatical-leaves`;
export const leaveOfAbsencesUrl = `${RoutingPattern.admin}/leave-of-absences`;
